import { Component, ojs, app, payload } from "modular-openscriptjs";
import { dom, tool } from "../fotastart";
import Layout from "./Layout";
import Loader from "./Blocks/Loader";
import Confirmation from "./Confirmation";
import MainActionForm from "./Forms/MainActionForm";
import Spinner from "./Blocks/Spinner";
import { disposeBootstrapTree, isMobile, store, getStore } from "../helpers";
import LoadingScreen from "./LoadingScreen";
import { $e } from "../ojs.events";
import { gc } from "../ojs.contexts";
import { Capacitor } from "@capacitor/core";
import Swal from "sweetalert2";

const h = app("h");
const broker = app("broker");
const router = app("router");

ojs(
    Loader,
    Layout,
    Confirmation,
    MainActionForm,
    Spinner,
    Loader,
    LoadingScreen,
);

export default class App extends Component {
    $$ui = {
        needs: {
            loginForm: (ed, event) => router.to("user.login"),
        },
    };

    $$system = {
        booted: () => {
            this.showAppDownloadPrompt();
        },
    };

    $$app = {
        needs: {
            to: {
                scrollToTop: () => {
                    dom.get(`[app-hook='top-marker']`)?.scrollIntoView({
                        behavior: "smooth",
                    });
                },
            },
        },
    };

    async showAppDownloadPrompt() {
        if (!Capacitor.isNativePlatform() && isMobile()) {
            const lastShown = await getStore("app_download_prompt_last_shown");
            const today = new Date().toDateString();
            if (lastShown && lastShown.date === today) {
                return;
            }

            Swal.fire({
                title: "Get the Carata App",
                html: `
					<p style="font-size: 1.1rem; color: #4b5563; margin-bottom: 1.5rem;">
						For the best experience, download the Carata Rider Mobile App.
					</p>
					<div style="display: flex; flex-direction: column; gap: 0.75rem; align-items: center; justify-content: center;">
						<a href="#" class="btn btn-dark w-100 d-flex align-items-center justify-content-center gap-2 py-2.5" style="border-radius: 0.5rem; font-weight: 500;">
							<i class="bi bi-android2 fs-5"></i> Download for Android
						</a>
						<a href="#" class="btn btn-outline-dark w-100 d-flex align-items-center justify-content-center gap-2 py-2.5" style="border-radius: 0.5rem; font-weight: 500;">
							<i class="bi bi-apple fs-5"></i> Download on the App Store
						</a>
					</div>
				`,
                showConfirmButton: false,
                showCloseButton: true,
                focusConfirm: false,
                background: "#ffffff",
                customClass: {
                    popup: "rounded-4 shadow-lg border-0",
                },
            });

            await store("app_download_prompt_last_shown", { date: today });
        }
    }

    render(appLoaded, ...args) {
        if (!appLoaded.value) {
            return h.LoadingScreen(...args);
        }

        return h.Layout(gc.auth, ...args);
    }

    cleanUp() {
        super.cleanUp();
        let markup = this.markup();

        for (let elem of markup) {
            disposeBootstrapTree(elem);
        }
    }
}

ojs(App);
